export const SCHEDULE_CORRECTED_LIVE_BEHAVIOR_OPTIONS = [
  {
    value: 'require_review',
    label: 'Require commissioner review',
    description:
      'Schedule-corrected matchups stay in Needs Attention until a commissioner resolves them.',
  },
  {
    value: 'allow_auto_show_when_corrected_and_high_confidence',
    label: 'Allow auto-show when corrected and high confidence',
    description:
      'After schedule context is corrected, eligible games may appear on League Home when confidence is high enough.',
  },
] as const;

export const UNKNOWN_MATCHUP_BEHAVIOR_OPTIONS = [
  {
    value: 'needs_attention',
    label: 'Send to Needs Attention',
    description: 'Uncertain matchups are routed to Needs Attention instead of League Home.',
  },
  {
    value: 'hide',
    label: 'Hide from League Home',
    description: 'Uncertain matchups stay off League Home until manually reviewed elsewhere.',
  },
] as const;

export function isScheduleCorrectedAutoShowEnabled(behavior?: string | null): boolean {
  return behavior === 'allow_auto_show_when_corrected_and_high_confidence';
}

export function clampLiveConfidence(value: number): number {
  return Math.max(75, Math.min(100, Math.round(value)));
}
